// Styled dropdown for variant pickers. Delegated on document because the theme
// replaces the whole <variant-picker> markup after every variant change.
(() => {
  if (window.__styledSelect) return;
  window.__styledSelect = true;

  const parts = (el) => {
    const root = el.closest('.styled-select');
    return root && {
      root,
      native: root.querySelector('.styled-select__native'),
      button: root.querySelector('.styled-select__button'),
      list: root.querySelector('.styled-select__list'),
    };
  };
  const options = (list) => Array.from(list.querySelectorAll('[role="option"]'));

  const close = (p, focusButton) => {
    p.list.hidden = true;
    p.button.setAttribute('aria-expanded', 'false');
    if (focusButton) p.button.focus();
  };
  const closeAll = (except) => {
    document.querySelectorAll('.styled-select__button[aria-expanded="true"]').forEach((b) => {
      const p = parts(b);
      if (p && p.root !== except) close(p, false);
    });
  };
  const open = (p) => {
    closeAll(p.root);
    p.list.hidden = false;
    p.button.setAttribute('aria-expanded', 'true');
    const current = p.list.querySelector('[aria-selected="true"]') || options(p.list)[0];
    if (current) {
      current.focus({ preventScroll: true });
      current.scrollIntoView({ block: 'nearest' });
    }
  };
  const choose = (p, item) => {
    const value = item.getAttribute('data-value');
    close(p, true);
    if (p.native.value === value) return;
    options(p.list).forEach((o) => o.setAttribute('aria-selected', String(o === item)));
    p.button.querySelector('.styled-select__value').textContent = item.firstElementChild.textContent;
    p.native.value = value;
    p.native.dispatchEvent(new Event('change', { bubbles: true }));
  };

  document.addEventListener('click', (e) => {
    const button = e.target.closest('.styled-select__button');
    if (button) {
      e.preventDefault(); // stops a wrapping <label> from toggling its checkbox
      const p = parts(button);
      button.getAttribute('aria-expanded') === 'true' ? close(p, false) : open(p);
      return;
    }
    const item = e.target.closest('.styled-select__option');
    if (item) {
      e.preventDefault();
      return choose(parts(item), item);
    }
    closeAll(null);
  });

  document.addEventListener('keydown', (e) => {
    const p = parts(e.target);
    if (!p || !p.button) return;
    if (e.target === p.button) {
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(e.key)) {
        e.preventDefault();
        open(p);
      }
      return;
    }
    if (!e.target.matches('.styled-select__option')) return;
    const items = options(p.list);
    const i = items.indexOf(e.target);
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      const next = items[(i + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length];
      next.focus();
    } else if (e.key === 'Home' || e.key === 'End') {
      e.preventDefault();
      items[e.key === 'Home' ? 0 : items.length - 1].focus();
    } else if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      choose(p, e.target);
    } else if (e.key === 'Escape' || e.key === 'Tab') {
      if (e.key === 'Escape') e.preventDefault();
      close(p, e.key === 'Escape');
    }
  });
})();
